/* eslint-disable @typescript-eslint/no-floating-promises */
import { EventType } from 'constants/enums'
import { CarComparisonStore } from '../store'
import { MyPicksPageCard } from '../vehicle-card/my-picks-page-card'
import { TrimSelectorCheckbox } from './trim-selector-checkbox'

/**
 * Trim Selector modal component
 */
export class TrimSelectorMyPicks extends TrimSelectorCheckbox {
    protected get myPicksLength(): number {
        return (
            CarComparisonStore.getInstance().get().length -
            this.preSelected.length
        )
    }

    public constructor(id: string) {
        super(id)
    }

    /**
     * Bind event listeners
     */
    protected bindListeners(): void {
        this.compareButton.addEventListener(EventType.CLICK, () => {
            this.addToMyPicks()
        })
        super.bindListeners()
    }

    /**
     * Add to MyPicks
     */
    public async addToMyPicks(): Promise<void> {
        // Remove all pre-selected vehicle(s) from my picks
        this.preSelected.forEach((id) => {
            CarComparisonStore.getInstance().remove(id)
        })

        // Add new checked items into my picks
        for (const vehicleId of this.checkedItems) {
            await CarComparisonStore.getInstance().add(vehicleId)
        }

        // Reset checked items and close modal
        super.addToMyPicks()

        // Get vehicle ids to reload page
        const vehicles = CarComparisonStore.getInstance().get()
        const vehicleIds = vehicles.map((vehicle) => vehicle.id)

        // Reload page after update vehicle trim(s)
        this.reloadPage(vehicleIds.join(','))
    }

    /**
     * Open Trim Selector modal
     * Replace the model information and fetch trims from API
     *
     * @param {string} image Image URL
     * @param {number} year
     * @param {string} make
     * @param {string} model
     */
    public async openTrimSelector(myPicksCard: MyPicksPageCard): Promise<void> {
        void this.handleTrimSelector(myPicksCard)
    }
}
